export default __webpack_public_path__ + "static/1-a36e1364ed4cd69c2d4a33a0fa9f998f.webp";